import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeThree/copy-icon.png'


const _hoisted_1 = { class: "bauContainer" }
const _hoisted_2 = { class: "menuLinkCont" }
const _hoisted_3 = { class: "menuLinkWrapper" }
const _hoisted_4 = { class: "linkCopy" }
const _hoisted_5 = { class: "menueLinkTxt" }
const _hoisted_6 = { class: "menueLinkBtTxt" }
const _hoisted_7 = { class: "mediaListMain" }
const _hoisted_8 = { class: "mediaListScroll" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {} }
const _hoisted_11 = { style: {"color":"#F5A130"} }
const _hoisted_12 = { style: {"color":"#ffff"} }
const _hoisted_13 = { class: "recordsCard" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "arrow"
}
const _hoisted_16 = { class: "rulesCard" }
const _hoisted_17 = { style: {"padding":".25rem 0"} }
const _hoisted_18 = { style: {"color":"#9BA7BE"} }
const _hoisted_19 = { class: "conditionCheckContainer" }
const _hoisted_20 = { style: {"color":"#1680DC"} }
const _hoisted_21 = { class: "conditionCheckContainer" }
const _hoisted_22 = { style: {"color":"#1680DC"} }
const _hoisted_23 = {
  class: "conditionCheckContainer",
  style: {"border":"none"}
}
const _hoisted_24 = { style: {"color":"#1680DC"} }
const _hoisted_25 = { class: "rulesCard" }
const _hoisted_26 = { class: "bottom_text" }
const _hoisted_27 = { class: "title" }

import { computed, ref } from 'vue';
import RewardBox from './components/rewardBox.vue';
import { toZigZagWithFlags, toZigZagWithFlagsAdvance } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { MEDIA_LIST, TreasureData } from '@/view/bauDoTesouro/supportScript';
import { copyValue } from '@/view/bauDoTesouro/supportScript'
import StatusPopup from '@/components/common/statusPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'bauDoTesouroView',
  props: {
    dataSet: {}
  },
  emits: ['goToShare', 'goToUserDetails'],
  setup(__props: any, { emit: __emit }) {

const mediaList = ref(MEDIA_LIST)
const statusRef = ref()
const props = __props

const emits = __emit
const zigzagReordered = computed<any>(() => {
    return props.dataSet.activityConfig?.reward_conf
})

const goToShare = async () => {
    emits('goToShare')
}
const goToUserDetails = async () => {
    emits('goToUserDetails')
}
const handleCopyValue = () => {
    copyValue(props.dataSet.activityConfig?.link, () => {
        statusRef.value?.open()
    })
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bauDoTesouro.treasure')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, { class: "secContainer" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.myLink')) + " " + _toDisplayString(_ctx.dataSet.activityConfig?.link), 1),
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCopyValue()))
                    })
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", {
                    class: "divider",
                    style: {"top":"25%"}
                  }, null, -1)),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('common.quickShare')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "mediaList",
                          onClick: goToShare,
                          style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}
                        }, [
                          _createElementVNode("img", {
                            src: item.icon,
                            style: {"height":"50.75px","width":"50.75px"},
                            class: "",
                            alt: ""
                          }, null, 8, _hoisted_9)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", {
                    class: "divider",
                    style: {"top":"75%"}
                  }, null, -1)),
                  _createElementVNode("div", {
                    onClick: goToUserDetails,
                    style: {"position":"absolute","top":"75%","width":"100%"}
                  }, [
                    _createVNode(_component_van_row, { style: {"padding":"0px 15px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "15",
                          class: "myReport"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('bauDoTesouro.myReports')), 1),
                            _createElementVNode("p", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.dataSet.activityConfig?.valid_user_count) + " " + _toDisplayString(_ctx.$t('common.pepole')), 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(' (' + _ctx.$t('common.valid')), 1),
                              _createTextVNode(" " + _toDisplayString(`
                                        ${_ctx.dataSet.activityConfig?.valid_user_count})`), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, {
                          span: "9",
                          style: {"display":"flex","justify-content":"flex-end","align-items":"center","color":"#1680dc"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('treasure.details') + ' >'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_van_row, { class: "cardRow" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zigzagReordered.value, (value, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "cardCol",
                          style: {"width":"25%"}
                        }, [
                          (!value.isNullObject)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(RewardBox, {
                                  peopleCount: value.valid_count,
                                  reward: value.reward,
                                  side: value.side,
                                  down: value.turnDown,
                                  isInCorner: value.isInCorner,
                                  received: value?.received,
                                  isLast: value.isLast
                                }, null, 8, ["peopleCount", "reward", "side", "down", "isInCorner", "received", "isLast"]),
                                (Number(index) % 4 !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[3] || (_cache[3] = [
                                      _createElementVNode("span", null, ">", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_van_row, { style: {"padding":"10px","color":"#6D788D"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('mystery.effectivePromotion')), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"width":"100%","height":"1px","background":"#1a233e"} }, null, -1)),
        _createVNode(_component_van_row, { style: {"padding":"0px 10px 10px 10px","color":"#6D788D"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_van_col, { span: 18 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('mystery.requiredDeposit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 6,
                style: {"display":"flex","justify-content":"flex-end"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_20, _toDisplayString('≥') + _toDisplayString(parseFloat(_ctx.dataSet.activityConfig?.recharge_require).toFixed(2).toString().replace('.', ',')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_van_col, { span: 18 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('mystery.requiredTurnove')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 6,
                style: {"display":"flex","justify-content":"flex-end"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_22, _toDisplayString('≥') + _toDisplayString(parseFloat(_ctx.dataSet.activityConfig?.turnover_require).toFixed(2).toString().replace('.',
                                ',')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_van_col, { span: 18 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('report.ipLimit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 6,
                style: {"display":"flex","justify-content":"flex-end"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.dataSet.activityConfig?.ip_limit), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("tresure.rule")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.descriptionHtml, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        content: _ctx.$t('common.successfullyCopied'),
        isShowSuccess: true
      }, null, 8, ["content"])
    ])
  ], 64))
}
}

})